import type { FunctionReturnType } from "convex/server";
import type { api } from "../../../../convex/_generated/api";

export type Conversation = FunctionReturnType<typeof api.communication.listConversations>[number];
export type Message = FunctionReturnType<typeof api.communication.listMessages>["page"][number];
export type Member = FunctionReturnType<typeof api.communication.listMembers>[number];
export type Participant = FunctionReturnType<typeof api.communication.listParticipants>[number];
export type AgentPolicy = FunctionReturnType<typeof api.communication.listAgentPolicies>[number];
export type Invitation = FunctionReturnType<typeof api.communication.listInvitations>[number];
export type SearchHit = FunctionReturnType<typeof api.communication.searchMessages>[number];
export type PinnedMessage = FunctionReturnType<typeof api.communication.listPins>[number];
export type MeReady = Extract<FunctionReturnType<typeof api.workspace.me>, { status: "ready" }>;

export function isAdmin(role: string): boolean {
  return role === "owner" || role === "admin";
}

export function conversationLabel(conversation: Conversation): string {
  if (conversation.type === "direct") return conversation.partner?.displayName ?? "Direct message";
  return conversation.name ?? "channel";
}
